import { render, staticRenderFns } from "./BusinessNameMessages.vue?vue&type=template&id=0ecabeb0&scoped=true&"
import script from "./BusinessNameMessages.vue?vue&type=script&lang=js&"
export * from "./BusinessNameMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecabeb0",
  null
  
)

export default component.exports